<template>
  <div class="ele-checklist">
    <div @click="detail()">
      <p class="tit-ele-checklist">{{this.item.clueName}}</p>
      <div class="info-ele-checklist"><span>创建人:{{this.item.createByTxt}}</span><span class="color-gray">{{this.item.updateTimeDate}}</span></div>
      <p class="tag-ele-checklist bg-gray"
         v-if="item.status==clueParam.close">关闭</p>
      <p class="tag-ele-checklist bg-pl"
         v-if="item.status==clueParam.ing">跟进中</p>
      <p class="tag-ele-checklist bg-red"
         v-if="item.status==clueParam.na">未联系</p>
      <p class="tag-ele-checklist bg-blue"
         v-if="item.status==clueParam.trans">转销售</p>
    </div>
    <div class="content-center">
      <button class="trans-desc-check widthmax" @click="transCustomer">转成客户</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ClueItem',
  data() {
    return {}
  },
  props: ['item'],
  methods: {
    detail() {
      this.$router.push('/clueInfo/' + this.item.autoId)
    },
    transCustomer(){
      this.$router.push('/customer/0/'+this.item.autoId)
    }
  },
  computed: {
    ...mapState('systemAbout', ['clueParam']),
  },
}
</script>

<style scoped>
</style>